(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-pdp-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-lp-pdp-bundle]');
    if (!roots || !roots.length) return;

    function formatMoney(cents, format) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = parts.join('.');
      if (format && format.indexOf('{' + '{') !== -1) {
        return format.replace(/\{\{\s*amount[^}]*\}\}/g, formatted);
      }
      return '$' + formatted;
    }

    function setupBundle(root) {
      var mainInput = root.querySelector('[data-lp-pdp-bundle-main]');
      var addonInputs = root.querySelectorAll('[data-lp-pdp-bundle-addon-input]');
      var totalEl = root.querySelector('[data-lp-pdp-bundle-total]');
      var cta = root.querySelector('[data-lp-pdp-bundle-cta]');
      var ctaLabel = root.querySelector('[data-lp-pdp-bundle-cta-label]');
      var errorEl = root.querySelector('[data-lp-pdp-bundle-error]');

      if (!mainInput || !cta || !totalEl) return;

      var mainPrice = parseInt(mainInput.getAttribute('data-price'), 10) || 0;
      var moneyFormat = totalEl.getAttribute('data-money-format') || '${' + '{amount}}';

      function recompute() {
        var total = mainPrice;
        for (var i = 0; i < addonInputs.length; i++) {
          var inp = addonInputs[i];
          if (inp.checked && !inp.disabled) {
            total += parseInt(inp.getAttribute('data-price'), 10) || 0;
          }
        }
        totalEl.textContent = formatMoney(total, moneyFormat);
      }

      function collectItems() {
        var items = [];
        var mainId = mainInput.getAttribute('data-variant-id');
        if (mainId) items.push({ id: parseInt(mainId, 10), quantity: 1 });
        for (var i = 0; i < addonInputs.length; i++) {
          var inp = addonInputs[i];
          if (inp.checked && !inp.disabled) {
            var id = inp.getAttribute('data-variant-id');
            if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
          }
        }
        return items;
      }

      function setBusy(busy) {
        if (busy) {
          cta.setAttribute('aria-busy', 'true');
          cta.disabled = true;
          if (ctaLabel) ctaLabel.textContent = cta.getAttribute('data-label-loading') || ctaLabel.textContent;
        } else {
          cta.removeAttribute('aria-busy');
          cta.disabled = false;
          if (ctaLabel) ctaLabel.textContent = cta.getAttribute('data-label-default') || ctaLabel.textContent;
        }
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      for (var i = 0; i < addonInputs.length; i++) {
        addonInputs[i].addEventListener('change', recompute);
      }

      cta.addEventListener('click', function () {
        clearError();
        var items = collectItems();
        if (!items.length) return;

        setBusy(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, status: res.status, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              var msg = (result.data && (result.data.description || result.data.message)) || cta.getAttribute('data-label-default');
              throw new Error(msg);
            }
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { source: 'lp-pdp-bundle', items: items, response: result.data }
            }));
            try { window.location.href = '/cart'; } catch (e) { /* noop */ }
          })
          .catch(function (err) {
            showError((err && err.message) || 'Error');
            setBusy(false);
          });
      });

      recompute();
    }

    for (var i = 0; i < roots.length; i++) setupBundle(roots[i]);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-buy-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var cards = document.querySelectorAll('[data-lp-buy-card]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.getAttribute('data-lp-bound') === 'true') return;
      card.setAttribute('data-lp-bound', 'true');

      var mode = card.getAttribute('data-mode');

      var variantChips = card.querySelectorAll('[data-lp-variant-chips] .lp-pdp-buy-card__chip');
      var variantInput = card.querySelector('[data-lp-variant-input]');
      var priceEl = card.querySelector('[data-lp-price]');
      var comparePriceEl = card.querySelector('[data-lp-compare-price]');
      var installEl = card.querySelector('[data-lp-installments]');

      function moneyFormat(cents) {
        try {
          if (window.Shopify && window.Shopify.formatMoney) {
            return window.Shopify.formatMoney(cents, window.Shopify.money_format);
          }
        } catch (e) {}
        var n = (cents / 100).toFixed(2);
        return '$' + n;
      }

      function renderInstallments(newPriceCents) {
        if (!installEl) return;
        var tpl = installEl.getAttribute('data-installments-template') || '';
        var count = parseInt(installEl.getAttribute('data-installments-count'), 10);
        if (!tpl || !count || isNaN(count) || count < 2 || isNaN(newPriceCents) || newPriceCents <= 0) return;
        var perInst = Math.floor(newPriceCents / count);
        var out = tpl
          .replace('{count}', String(count))
          .replace('{amount}', moneyFormat(perInst));
        installEl.textContent = out;
      }

      variantChips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.getAttribute('aria-disabled') === 'true') return;
          variantChips.forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');

          var vid = chip.getAttribute('data-variant-id');
          var variantId = parseInt(vid, 10);
          if (variantInput && vid) {
            variantInput.value = vid;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          var newPrice = parseInt(chip.getAttribute('data-variant-price'), 10);
          var priceFormatted = chip.getAttribute('data-variant-price-money');
          if (priceEl && priceFormatted) {
            priceEl.textContent = priceFormatted;
          }

          var compareFormatted = chip.getAttribute('data-variant-compare-money');
          if (comparePriceEl && compareFormatted) {
            comparePriceEl.textContent = compareFormatted;
          }

          renderInstallments(newPrice);

          var availableAttr = chip.getAttribute('data-variant-available');
          var available = availableAttr === 'true';

          var mediaIdAttr = chip.getAttribute('data-media-id');
          var mediaId = null;
          if (mediaIdAttr) {
            var parsedMediaId = parseInt(mediaIdAttr, 10);
            mediaId = isNaN(parsedMediaId) ? null : parsedMediaId;
          }

          document.dispatchEvent(new CustomEvent('lp:variant:change', {
            bubbles: true,
            detail: {
              variantId: isNaN(variantId) ? null : variantId,
              variantPrice: isNaN(newPrice) ? null : newPrice,
              priceFormatted: priceFormatted || null,
              available: available,
              mediaId: mediaId
            }
          }));
        });
      });

      // With volume tiers the chips are replaced by lp-pdp-volume-tiers, which
      // emits the same lp:variant:change event. Mirror the headline price /
      // installments off the event so the card stays in sync either way.
      document.addEventListener('lp:variant:change', function (e) {
        if (!e.detail) return;
        if (priceEl && e.detail.priceFormatted) {
          priceEl.textContent = e.detail.priceFormatted;
        }
        renderInstallments(e.detail.variantPrice);
      });

      var stepper = card.querySelector('[data-lp-stepper]');
      if (stepper) {
        var qtyInput = stepper.querySelector('[data-lp-qty-input]');
        var decBtn = stepper.querySelector('[data-lp-qty-dec]');
        var incBtn = stepper.querySelector('[data-lp-qty-inc]');

        function clampQty() {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < 1) v = 1;
          qtyInput.value = v;
        }

        if (decBtn) {
          decBtn.addEventListener('click', function () {
            if (!qtyInput) return;
            var v = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = Math.max(1, v - 1);
          });
        }
        if (incBtn) {
          incBtn.addEventListener('click', function () {
            if (!qtyInput) return;
            var v = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = v + 1;
          });
        }
        if (qtyInput) {
          qtyInput.addEventListener('change', clampQty);
          qtyInput.addEventListener('blur', clampQty);
        }
      }

      if (mode === 'quote') {
        var quoteChips = card.querySelectorAll('[data-lp-quote-chips] .lp-pdp-buy-card__chip');
        var waCta = card.querySelector('[data-lp-wa-cta]');

        quoteChips.forEach(function (chip) {
          chip.addEventListener('click', function () {
            if (chip.getAttribute('aria-disabled') === 'true') return;
            quoteChips.forEach(function (c) {
              c.classList.remove('is-active');
              c.setAttribute('aria-pressed', 'false');
            });
            chip.classList.add('is-active');
            chip.setAttribute('aria-pressed', 'true');

            var presentation = chip.getAttribute('data-presentation') || '';
            card.setAttribute('data-lp-presentation', presentation);

            if (waCta) {
              var base = waCta.getAttribute('data-base-message') || '';
              var msg = base;
              if (presentation) {
                msg = base + ' (' + presentation + ')';
              }
              var hrefParts = waCta.href.split('?text=');
              if (hrefParts.length === 2) {
                var prefix = hrefParts[0];
                waCta.href = prefix + '?text=' + encodeURIComponent(msg);
              }
            }

            document.dispatchEvent(new CustomEvent('lp:presentation:change', {
              bubbles: true,
              detail: { value: presentation }
            }));
          });
        });

        var scrollCta = card.querySelector('[data-lp-quote-scroll]');
        if (scrollCta) {
          scrollCta.addEventListener('click', function (e) {
            var target = document.getElementById('cotizar');
            if (target) {
              e.preventDefault();
              var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              target.scrollIntoView({
                behavior: prefersReduced ? 'auto' : 'smooth',
                block: 'center'
              });
            }
          });
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var galleries = document.querySelectorAll('[data-lp-pdp-gallery]');
    if (!galleries.length) return;

    // Document-level listener for variant changes — bound exactly once across
    // the whole page, even if multiple galleries re-render or if the IIFE
    // runs again. Uses a flag on document so re-renders don't double-bind.
    if (!document.__lpPdpGalleryVariantBound) {
      document.__lpPdpGalleryVariantBound = true;
      document.addEventListener('lp:variant:change', function (e) {
        if (!e || !e.detail) return;
        var mediaId = e.detail.mediaId;
        if (mediaId === null || mediaId === undefined || mediaId === 0 || mediaId === '') return;
        var allGalleries = document.querySelectorAll('[data-lp-pdp-gallery]');
        allGalleries.forEach(function (g) {
          if (typeof g.__lpPdpSetActiveByMediaId === 'function') {
            g.__lpPdpSetActiveByMediaId(mediaId);
          }
        });
      });
    }

    galleries.forEach(function (gallery) {
      if (gallery.dataset.lpPdpGalleryInit === '1') return;
      gallery.dataset.lpPdpGalleryInit = '1';

      var thumbs = gallery.querySelectorAll('[data-lp-pdp-thumb]');
      var slides = gallery.querySelectorAll('[data-lp-pdp-slide]');
      var viewport = gallery.querySelector('[data-lp-pdp-viewport]');
      var dots = gallery.querySelectorAll('[data-lp-pdp-dot]');
      var desktopMql = window.matchMedia('(min-width: 900px)');

      function setActiveIndex(index) {
        thumbs.forEach(function (t) {
          var isActive = parseInt(t.dataset.index, 10) === index;
          t.classList.toggle('lp-pdp-gallery__thumb--active', isActive);
          t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        dots.forEach(function (d) {
          var isActive = parseInt(d.dataset.index, 10) === index;
          d.classList.toggle('lp-pdp-gallery__dot--active', isActive);
          d.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      // Slide-toggle approach (works for mixed image/video media). Replaces
      // the old in-place src swap which broke when the first slide was a
      // <video> (mutating its src destroyed the <source> children and froze
      // the gallery). Each slide stays in the DOM with its proper element
      // type (img / video / gif-img); we just toggle visibility via the
      // --active class that the CSS already styles. For videos we also
      // play/pause per slide so off-screen videos don't keep streaming.
      function switchToSlide(index) {
        slides.forEach(function (slide) {
          var slideIdx = parseInt(slide.dataset.index, 10);
          var isTarget = slideIdx === index;
          slide.classList.toggle('lp-pdp-gallery__slide--active', isTarget);
          slide.setAttribute('aria-hidden', isTarget ? 'false' : 'true');

          var video = slide.querySelector('video');
          if (video) {
            if (isTarget) {
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          }
        });
      }

      function activateThumb(thumb) {
        var index = parseInt(thumb.dataset.index, 10);
        if (isNaN(index)) return;
        switchToSlide(index);
        setActiveIndex(index);
      }

      function setActiveByMediaId(mediaId) {
        if (mediaId === null || mediaId === undefined || mediaId === 0 || mediaId === '') return false;
        var mediaIdStr = String(mediaId);
        var matchingThumb = null;
        thumbs.forEach(function (t) {
          if (matchingThumb) return;
          if (t.dataset.mediaId && t.dataset.mediaId === mediaIdStr) {
            matchingThumb = t;
          }
        });
        if (matchingThumb) {
          activateThumb(matchingThumb);
          // For mobile carousel: scroll to the matching slide
          var idx = parseInt(matchingThumb.dataset.index, 10);
          if (!isNaN(idx) && viewport && !desktopMql.matches) {
            var targetSlide = gallery.querySelector('[data-lp-pdp-slide][data-index="' + idx + '"]');
            if (targetSlide) {
              viewport.scrollTo({
                left: targetSlide.offsetLeft,
                behavior: 'smooth'
              });
            }
          }
          return true;
        }
        return false;
      }

      // Expose for the document-level listener
      gallery.__lpPdpSetActiveByMediaId = setActiveByMediaId;

      var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateThumb(thumb);
        });
        if (canHover) {
          thumb.addEventListener('mouseenter', function () {
            activateThumb(thumb);
          });
        }
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.index, 10);
          if (isNaN(index)) return;
          var targetSlide = gallery.querySelector('[data-lp-pdp-slide][data-index="' + index + '"]');
          if (targetSlide && viewport) {
            viewport.scrollTo({
              left: targetSlide.offsetLeft,
              behavior: 'smooth'
            });
          }
          setActiveIndex(index);
        });
      });

      if (viewport && slides.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (desktopMql.matches) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var idx = parseInt(entry.target.dataset.index, 10);
              if (!isNaN(idx)) setActiveIndex(idx);
            }
          });
        }, {
          root: viewport,
          threshold: [0.6]
        });
        slides.forEach(function (slide) {
          io.observe(slide);
        });
      }

      // Init: activar el slide inicial (el primero, o el que venga marcado
      // como activo del server) y REPRODUCIR su video. switchToSlide solo se
      // llamaba al cambiar de slide, así que el primer video quedaba en el
      // poster hasta hacer click en otra foto y volver.
      var lpActiveSlide = gallery.querySelector('.lp-pdp-gallery__slide--active');
      var lpInitIdx = lpActiveSlide ? parseInt(lpActiveSlide.dataset.index, 10) : 0;
      if (isNaN(lpInitIdx)) lpInitIdx = 0;
      switchToSlide(lpInitIdx);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-quote-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var roots = document.querySelectorAll('[data-lpp-quote-form]');
      if (!roots.length) return;

      roots.forEach(function (root) {
        if (root.hasAttribute('data-lp-bound')) return;
        root.setAttribute('data-lp-bound', '');

        // Focus the success card if present so SR users hear the
        // confirmation and visual users see the card on submit redirect.
        var successCard = root.querySelector('[data-lp-quote-success]');
        if (successCard) {
          try { successCard.focus({ preventScroll: false }); } catch (e) { successCard.focus(); }
          if (typeof successCard.scrollIntoView === 'function') {
            successCard.scrollIntoView({ block: 'center' });
          }
        }

        var presentationInput = root.querySelector('[data-lpp-presentation-input]');
        if (!presentationInput) return;

        function readPresentation() {
          var buyCard = document.querySelector('[data-lp-buy-card]');
          if (buyCard) {
            var dsAttr = buyCard.getAttribute('data-lp-presentation');
            if (dsAttr && dsAttr.length) return dsAttr;
            var dsHidden = buyCard.querySelector('[data-lpp-presentation-source]');
            if (dsHidden && dsHidden.value) return dsHidden.value;
          }
          var anyHidden = document.querySelector('[data-lpp-presentation-source]');
          if (anyHidden && anyHidden.value) return anyHidden.value;
          return '';
        }

        function sync() {
          var v = readPresentation();
          if (presentationInput.value !== v) {
            presentationInput.value = v;
          }
        }

        sync();

        var buyCard = document.querySelector('[data-lp-buy-card]');
        if (buyCard) {
          var observer = new MutationObserver(sync);
          observer.observe(buyCard, {
            attributes: true,
            attributeFilter: ['data-lp-presentation'],
            subtree: false
          });

          buyCard.addEventListener('change', sync, true);
          buyCard.addEventListener('click', function () {
            setTimeout(sync, 0);
          }, true);
        }

        document.addEventListener('lp:presentation:change', function (e) {
          if (e && e.detail && typeof e.detail.value === 'string') {
            presentationInput.value = e.detail.value;
          } else {
            sync();
          }
        });

        var form = root.querySelector('form');
        if (form) {
          form.addEventListener('submit', sync, true);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      var root = document.querySelector('[data-lp-pdp-sticky-bar]');
      if (!root) return;
      if (root.hasAttribute('data-lp-bound')) return;
      root.setAttribute('data-lp-bound', '');

      // Smooth-scroll on the quote-CTA anchor.
      var quoteLink = root.querySelector('[data-lp-pdp-sticky-bar-quote]');
      if (quoteLink) {
        quoteLink.addEventListener('click', function (event) {
          var hash = quoteLink.getAttribute('href') || '';
          if (hash.charAt(0) !== '#') return;
          var targetId = hash.slice(1);
          if (!targetId) return;
          var target = document.getElementById(targetId);
          if (!target) return;

          event.preventDefault();

          var prefersReducedMotion = false;
          if (window.matchMedia) {
            prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          }

          target.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });

          if (history && typeof history.replaceState === 'function') {
            history.replaceState(null, '', hash);
          }
        });
      }

      // Expose actual rendered height via CSS var so the section can pad
      // the footer / reserve space without hardcoding a magic number.
      function measureHeight() {
        var rect = root.getBoundingClientRect();
        var h = Math.ceil(rect.height || 0);
        document.documentElement.style.setProperty('--lp-sticky-bar-h', h + 'px');
      }
      measureHeight();
      window.addEventListener('resize', measureHeight);
      window.addEventListener('orientationchange', measureHeight);

      // Format money helper: mirrors the Liquid money filter when Shopify is
      // available, falls back to a best-effort UYU/locale-aware formatter.
      function formatMoney(cents) {
        if (typeof cents !== 'number' || isNaN(cents)) return '';
        if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
          try { return Shopify.formatMoney(cents, Shopify.money_format); } catch (e) {}
        }
        var amount = (cents / 100);
        try {
          return amount.toLocaleString(undefined, { style: 'currency', currency: 'UYU' });
        } catch (e) {
          return '$' + amount.toFixed(2);
        }
      }

      // Products with volume tiers sell a MULTI-variant selection, not a unit:
      // once the volume block speaks it owns the price stack and the CTA, and
      // the per-variant broadcasts below stop applying.
      var volumeMode = false;
      var sbCompareEl = root.querySelector('[data-lp-sb-compare]');
      var sbCompareValueEl = root.querySelector('[data-lp-sb-compare-value]');

      document.addEventListener('lp:volume:change', function (e) {
        if (!e || !e.detail) return;
        volumeMode = true;

        var priceEl = root.querySelector('[data-lp-sb-price]');
        if (priceEl && e.detail.totalFormatted) {
          priceEl.textContent = e.detail.totalFormatted;
        }

        if (sbCompareEl && sbCompareValueEl) {
          if (e.detail.percentage > 0 && e.detail.subtotal > 0) {
            sbCompareValueEl.textContent = e.detail.subtotalFormatted || '';
            sbCompareEl.hidden = false;
          } else {
            sbCompareEl.hidden = true;
          }
        }

        var volumeCtaState = root.querySelector('[data-lp-sb-cta]');
        if (volumeCtaState) {
          if (e.detail.units === 0) {
            volumeCtaState.classList.add('is-unavailable');
            if ('disabled' in volumeCtaState) volumeCtaState.disabled = true;
            volumeCtaState.setAttribute('aria-disabled', 'true');
          } else {
            volumeCtaState.classList.remove('is-unavailable');
            if ('disabled' in volumeCtaState) volumeCtaState.disabled = false;
            volumeCtaState.removeAttribute('aria-disabled');
          }
        }

        measureHeight();
      });

      // Hand the CTA over to the volume block so the bar adds the WHOLE
      // selection (every presentation with qty > 0), not a single unit of the
      // variant that happens to sit in the hidden id input.
      var stickyForm = root.querySelector('form');
      if (stickyForm) {
        stickyForm.addEventListener('submit', function (event) {
          var volumeCta = document.querySelector('[data-lp-volume-cta="cart"]');
          if (!volumeCta) return;
          event.preventDefault();
          volumeCta.click();
        });
      }

      // The volume block may have initialised before this listener existed —
      // ask it to re-broadcast rather than waiting for the first stepper tap.
      if (document.querySelector('[data-lp-volume]')) {
        volumeMode = true;
        document.dispatchEvent(new CustomEvent('lp:volume:sync'));
      }

      // Subscribe to variant changes broadcast by the buy-card. Updates the
      // hidden id, the displayed price, and the CTA availability label.
      document.addEventListener('lp:variant:change', function (e) {
        if (!e || !e.detail) return;
        if (volumeMode) return;
        var input = root.querySelector('input[name="id"]');
        if (input && e.detail.variantId) {
          input.value = e.detail.variantId;
        }
        var priceEl = root.querySelector('[data-lp-sb-price]');
        if (priceEl) {
          // Prefer pre-formatted money string from the event detail (rendered
          // server-side via the Liquid money filter, so it honors the
          // shop-level currency format, e.g. UYU "$1.680,00"). Fall back to
          // computing client-side only if priceFormatted is missing.
          if (typeof e.detail.priceFormatted === 'string' && e.detail.priceFormatted) {
            priceEl.textContent = e.detail.priceFormatted;
          } else if (typeof e.detail.variantPrice === 'number') {
            priceEl.textContent = formatMoney(e.detail.variantPrice);
          }
        }
        var cta = root.querySelector('[data-lp-sb-cta]');
        if (cta) {
          var labelEl = cta.querySelector('[data-lp-sb-label]');
          var addLabel = cta.getAttribute('data-add-label') || '';
          var soldOutLabel = cta.getAttribute('data-sold-out-label') || '';
          if (e.detail.available === false) {
            cta.classList.add('is-unavailable');
            if ('disabled' in cta) cta.disabled = true;
            cta.setAttribute('aria-disabled', 'true');
            if (labelEl && soldOutLabel) labelEl.textContent = soldOutLabel;
          } else {
            cta.classList.remove('is-unavailable');
            if ('disabled' in cta) cta.disabled = false;
            cta.removeAttribute('aria-disabled');
            if (labelEl && addLabel) labelEl.textContent = addLabel;
          }
        }
      });

      // Hide the sticky bar when the buy-card is well inside the viewport
      // (>= 50% visible) — the user already has the primary affordance.
      var buyCard = document.querySelector('[data-lp-buy-card]');
      if (buyCard && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              root.classList.add('is-hidden');
            } else {
              root.classList.remove('is-hidden');
            }
          });
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
        io.observe(buyCard);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdp-volume-tiers"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-lp-volume]');
    if (!roots.length) return;

    // Formats cents against the shop's money_format placeholder, so stores
    // using amount_with_comma_separator ($1.234,56) render correctly.
    function formatMoney(cents, format) {
      format = format || '${' + '{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var name = match ? match[1] : 'amount';
      var noDecimals = name.indexOf('no_decimals') !== -1;
      var commaDecimal = name.indexOf('comma_separator') !== -1;
      var amount = Math.round(cents) / 100;
      var fixed = noDecimals ? String(Math.round(amount)) : amount.toFixed(2);
      var pieces = fixed.split('.');
      var thousandsSep = commaDecimal ? '.' : ',';
      var out = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      if (pieces.length > 1) {
        out += (commaDecimal ? ',' : '.') + pieces[1];
      }
      return match ? format.replace(match[0], out) : out;
    }

    function setup(root) {
      if (root.getAttribute('data-lp-bound') === 'true') return;
      root.setAttribute('data-lp-bound', 'true');

      var moneyFormat = root.getAttribute('data-money-format');
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lp-volume-row]'));
      if (!rows.length) return;

      var tiers = Array.prototype.slice
        .call(root.querySelectorAll('[data-lp-volume-tier]'))
        .map(function (el) {
          return {
            el: el,
            min: parseInt(el.getAttribute('data-tier-min'), 10) || 0,
            pct: parseFloat(el.getAttribute('data-tier-pct')) || 0
          };
        })
        .sort(function (a, b) {
          return a.min - b.min;
        });

      var unitsEl = root.querySelector('[data-lp-volume-units]');
      var badgeEl = root.querySelector('[data-lp-volume-badge]');
      var subtotalEl = root.querySelector('[data-lp-volume-subtotal]');
      var totalEl = root.querySelector('[data-lp-volume-total]');
      var savingsEl = root.querySelector('[data-lp-volume-savings]');
      var nudgeEl = root.querySelector('[data-lp-volume-nudge]');
      var errorEl = root.querySelector('[data-lp-volume-error]');
      var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-lp-volume-cta]'));

      function t(key) {
        return root.getAttribute('data-t-' + key) || '';
      }

      function qtyInput(row) {
        return row.querySelector('[data-lp-volume-qty]');
      }

      function getQty(row) {
        var input = qtyInput(row);
        if (!input) return 0;
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 0) value = 0;
        return value;
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      function recompute() {
        var units = 0;
        var subtotal = 0;

        rows.forEach(function (row) {
          var qty = getQty(row);
          units += qty;
          subtotal += qty * (parseInt(row.getAttribute('data-price'), 10) || 0);
          if (qty > 0) {
            row.classList.add('is-selected');
          } else {
            row.classList.remove('is-selected');
          }
        });

        var applied = null;
        var next = null;
        tiers.forEach(function (tier) {
          if (units >= tier.min) {
            applied = tier;
          } else if (!next) {
            next = tier;
          }
        });

        tiers.forEach(function (tier) {
          if (applied && tier.min === applied.min) {
            tier.el.classList.add('is-active');
            tier.el.setAttribute('aria-current', 'true');
          } else {
            tier.el.classList.remove('is-active');
            tier.el.removeAttribute('aria-current');
          }
        });

        var pct = applied ? applied.pct : 0;
        var total = Math.round((subtotal * (100 - pct)) / 100);
        var savings = subtotal - total;

        if (unitsEl) {
          if (units === 1) {
            unitsEl.textContent = t('units-one');
          } else {
            unitsEl.textContent = t('units-many').replace('{count}', String(units));
          }
        }

        if (badgeEl) {
          if (pct > 0) {
            badgeEl.textContent = t('applied').replace('{pct}', String(pct));
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }

        if (subtotalEl) {
          if (pct > 0 && subtotal > 0) {
            subtotalEl.textContent = formatMoney(subtotal, moneyFormat);
            subtotalEl.hidden = false;
          } else {
            subtotalEl.hidden = true;
          }
        }

        if (totalEl) {
          totalEl.textContent = formatMoney(total, moneyFormat);
        }

        if (savingsEl) {
          if (savings > 0) {
            savingsEl.textContent = t('savings').replace('{amount}', formatMoney(savings, moneyFormat));
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }

        if (nudgeEl) {
          if (next && units > 0) {
            var missing = next.min - units;
            var template = missing === 1 ? t('nudge-one') : t('nudge-many');
            nudgeEl.textContent = template
              .replace('{count}', String(missing))
              .replace('{pct}', String(next.pct));
            nudgeEl.hidden = false;
          } else {
            nudgeEl.hidden = true;
          }
        }

        ctas.forEach(function (cta) {
          if (cta.getAttribute('aria-busy') === 'true') return;
          if (units === 0) {
            cta.disabled = true;
            cta.setAttribute('aria-disabled', 'true');
          } else {
            cta.disabled = false;
            cta.removeAttribute('aria-disabled');
          }
        });

        // The mobile sticky bar mirrors this summary — without it, it would
        // keep showing the unit price of whichever variant was last touched.
        document.dispatchEvent(new CustomEvent('lp:volume:change', {
          bubbles: true,
          detail: {
            units: units,
            percentage: pct,
            subtotal: subtotal,
            total: total,
            savings: savings,
            subtotalFormatted: formatMoney(subtotal, moneyFormat),
            totalFormatted: formatMoney(total, moneyFormat)
          }
        }));
      }

      // Keeps the gallery and the sticky bar pointed at the presentation the
      // customer is currently adjusting — they listen for lp:variant:change,
      // which the single-variant chips used to emit.
      function announceVariant(row) {
        var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
        var price = parseInt(row.getAttribute('data-price'), 10);
        var mediaIdAttr = row.getAttribute('data-media-id');
        var mediaId = mediaIdAttr ? parseInt(mediaIdAttr, 10) : NaN;

        document.dispatchEvent(new CustomEvent('lp:variant:change', {
          bubbles: true,
          detail: {
            variantId: isNaN(variantId) ? null : variantId,
            variantPrice: isNaN(price) ? null : price,
            priceFormatted: row.getAttribute('data-price-money') || null,
            available: true,
            mediaId: isNaN(mediaId) ? null : mediaId
          }
        }));
      }

      rows.forEach(function (row) {
        var input = qtyInput(row);
        var dec = row.querySelector('[data-lp-volume-dec]');
        var inc = row.querySelector('[data-lp-volume-inc]');

        function setQty(value) {
          if (!input) return;
          var next = Math.max(0, value);
          input.value = next;
          clearError();
          recompute();
          if (next > 0) announceVariant(row);
        }

        if (dec) {
          dec.addEventListener('click', function () {
            setQty(getQty(row) - 1);
          });
        }
        if (inc) {
          inc.addEventListener('click', function () {
            setQty(getQty(row) + 1);
          });
        }
        if (input) {
          input.addEventListener('change', function () {
            setQty(getQty(row));
          });
          input.addEventListener('blur', function () {
            setQty(getQty(row));
          });
        }
      });

      function collectItems() {
        var items = [];
        rows.forEach(function (row) {
          var qty = getQty(row);
          if (qty <= 0) return;
          var id = parseInt(row.getAttribute('data-variant-id'), 10);
          if (!isNaN(id)) {
            items.push({ id: id, quantity: qty });
          }
        });
        return items;
      }

      function setBusy(cta, busy) {
        var label = cta.querySelector('[data-lp-volume-cta-label]');
        if (busy) {
          cta.setAttribute('aria-busy', 'true');
          cta.disabled = true;
          if (label) label.textContent = cta.getAttribute('data-label-loading') || label.textContent;
        } else {
          cta.removeAttribute('aria-busy');
          cta.disabled = false;
          if (label) label.textContent = cta.getAttribute('data-label-default') || label.textContent;
        }
      }

      ctas.forEach(function (cta) {
        cta.addEventListener('click', function () {
          clearError();
          var items = collectItems();
          if (!items.length) {
            showError(t('empty'));
            return;
          }

          var destination = cta.getAttribute('data-lp-volume-cta') === 'checkout' ? '/checkout' : '/cart';
          setBusy(cta, true);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              return res.json().then(function (data) {
                return { ok: res.ok, data: data };
              });
            })
            .then(function (result) {
              if (!result.ok) {
                var message = (result.data && (result.data.description || result.data.message)) || t('empty');
                throw new Error(message);
              }
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { source: 'lp-pdp-volume-tiers', items: items, response: result.data }
              }));
              try {
                window.location.href = destination;
              } catch (e) {
                /* noop */
              }
            })
            .catch(function (err) {
              showError((err && err.message) || t('empty'));
              setBusy(cta, false);
            });
        });
      });

      // Lets a late-initialising listener (the sticky bar) ask for the current
      // state instead of waiting for the customer to touch a stepper.
      document.addEventListener('lp:volume:sync', function () {
        recompute();
      });

      recompute();
    }

    function init() {
      Array.prototype.forEach.call(roots, setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
